import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PropTypes from "prop-types";

export default function NoteTooltip({
  className,
  color,
  height = "17px",
  hideTooltip = false,
  icon = "fa-info-circle",
  note,
  placement,
  url,
  onClick = () => {}
}) {
  /* eslint react/no-danger: 0 */
  const tooltip = (
    <Tooltip className="in">
      <span dangerouslySetInnerHTML={{ __html: note }} />
    </Tooltip>
  );

  if (hideTooltip) {
    return <i className={`fa fa-fw ${icon} ${className}`} style={{ color }} />;
  }

  return (
    <OverlayTrigger placement={placement} overlay={tooltip} onClick={onClick}>
      {url ? (
        <img src={url} alt={note} height={height} className={className} />
      ) : (
        <i className={`fa fa-fw ${icon} ${className}`} style={{ color }} />
      )}
    </OverlayTrigger>
  );
}

NoteTooltip.defaultProps = {
  placement: "left",
  className: "",
  icon: "fa-sticky-note",
  color: "#ff9800"
};

NoteTooltip.propTypes = {
  placement: PropTypes.string,
  note: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  hideTooltip: PropTypes.bool,
  onClick: PropTypes.func,
  url: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/NoteTooltip/NoteTooltip.jsx